import angular from 'angular';

import styles from './styles.less';

import routes from './routes';

import template from './template.html'
import controller from './controller'

export default angular.module('app.main.panel.module.installerAccess', [])
	.component('installerAccess', {
		template: template,
		controller: controller,
		controllerAs: 'ctrl',
	})
	.name;


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/installerAccess.component/index.js
 **/